import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import api from "../lib/apiClient";

export default function PaymentResult({ success }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState(success ? "polling" : "cancelled");
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    if (!success) return;
    const sessionId = params.get("session_id");
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setPlan(data.plan); setState("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("error"); return; }
      } catch { /* keep polling */ }
      if (tries >= 8) { setState("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [success, params]);

  return (
    <div className="max-w-md mx-auto py-20 text-center" data-testid="payment-result">
      {state === "polling" && (<><Loader2 className="w-10 h-10 text-amber-500 animate-spin mx-auto mb-4" /><p className="text-zinc-300">Confirmation du paiement…</p></>)}
      {state === "paid" && (<>
        <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-4" />
        <h1 className="font-display text-2xl font-bold mb-2">Bienvenue en {plan} 🎉</h1>
        <p className="text-zinc-400 text-sm mb-6">Ton abonnement est actif. Toutes les fonctionnalités sont débloquées.</p>
        <button onClick={() => navigate("/dashboard")} data-testid="go-dashboard" className="px-6 h-11 rounded-xl gold-gradient text-black font-semibold">Aller au dashboard</button>
      </>)}
      {(state === "cancelled" || state === "error" || state === "timeout") && (<>
        <XCircle className="w-14 h-14 text-zinc-500 mx-auto mb-4" />
        <h1 className="font-display text-2xl font-bold mb-2">{state === "cancelled" ? "Paiement annulé" : state === "timeout" ? "Paiement en cours de traitement" : "Un souci est survenu"}</h1>
        <p className="text-zinc-400 text-sm mb-6">{state === "timeout" ? "Ton paiement est peut-être encore en traitement. Vérifie ton abonnement dans un instant." : "Aucun montant n'a été débité. Tu peux réessayer quand tu veux."}</p>
        <button onClick={() => navigate("/subscription")} data-testid="back-subscription" className="px-6 h-11 rounded-xl border border-zinc-700 text-zinc-200 font-medium">Retour aux abonnements</button>
      </>)}
    </div>
  );
}
